/**
 * Types for the TaskComposer scope menu. Scope constrains repos surfaced by the
 * composer (personal = user + public; organization = org + public). Billing is
 * unaffected.
 */

/** An organization the current user can scope the TaskComposer to. */
export interface AvailableOrganization {
  id: string
  login: string
  name: string
  avatarUrl: string
  /** True when the user still needs to complete SAML/SSO for this org. */
  requiresSso: boolean
}

/** The selected TaskComposer scope. */
export type TaskComposerScope = {kind: 'personal'} | {kind: 'organization'; organization: AvailableOrganization}

/** The default scope when no persisted selection exists. */
export const DEFAULT_TASK_COMPOSER_SCOPE: TaskComposerScope = {kind: 'personal'}

/** Convenience: extract the org login from a scope, or `undefined` for personal. */
export function scopeOrgLogin(scope: TaskComposerScope): string | undefined {
  return scope.kind === 'organization' ? scope.organization.login : undefined
}
